import React from 'react';
import { TheFooter, TheHeader } from './index';
import { useDispatch } from 'react-redux';

const ErrorPage = React.lazy(() => import('../views/err/errorPage'));

const TheErrorLayout = (props) => {


  return (
    <div className="c-app c-default-layout">
      <div className="c-wrapper">
        <TheHeader />
        <div className="c-body">
          <main className="c-main">
            <ErrorPage />
          </main>
        </div>
        <TheFooter />
      </div>
    </div>
  );
};

export default TheErrorLayout;
